import { DropdownMenuGroup, DropdownMenuItem } from '@customerio/pluma-components/react';

export function PersonalSettingsSection() {
  return (
    <DropdownMenuGroup>
      <DropdownMenuItem href="/settings/personal">Personal settings</DropdownMenuItem>
      <DropdownMenuItem href="/settings/experimental-features">Experimental features</DropdownMenuItem>
    </DropdownMenuGroup>
  );
}
